import { API_URL } from 'src/constants/urls';

export type ChatMessage = {
    id: number;
    role: 'user' | 'assistant';
    text: string;
    ai?: boolean;
    actions?: { label: string; path: string }[];
};

// Existing deployed public consultant: only the user's chat is sent, never account
// balances, contacts, lead text, tokens or business knowledge from the cabinet.
export async function askAssistant(message: string, history: ChatMessage[], signal: AbortSignal): Promise<string> {
    const response = await fetch(`${API_URL.replace(/\/$/, '')}/agent/public/assistant/`, {
        method: 'POST',
        credentials: 'omit',
        signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            message: message.slice(0, 600),
            history: history.slice(-8).map((m) => ({ role: m.role, content: m.text.slice(0, 800) })),
        }),
    }).catch((error) => {
        if (signal.aborted) throw error;
        throw new Error('Не удалось связаться с ИИ. Проверьте соединение и повторите.');
    });
    if (!response.ok)
        throw new Error(
            response.status === 429
                ? 'Слишком много запросов. Попробуйте чуть позже.'
                : 'ИИ сейчас не ответил. Можно повторить вопрос или обратиться в поддержку.'
        );
    const data = await response.json().catch(() => {
        throw new Error('Не удалось прочитать ответ ИИ. Попробуйте ещё раз.');
    });
    if (typeof data?.reply !== 'string' || !data.reply.trim())
        throw new Error('ИИ вернул пустой ответ. Попробуйте ещё раз.');
    return data.reply.trim().slice(0, 2400);
}
